import { ArrowRight, ShieldCheck, Clock, FileCheck2 } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const HERO_IMG = "https://images.unsplash.com/photo-1602757115429-b4190ae087be?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export default function Hero({ profile }) {
  const { t } = useSite();
  return (
    <section className="relative overflow-hidden blueprint-grid" data-testid="hero-section">
      <div className="mx-auto grid max-w-7xl grid-cols-12 gap-8 px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <div className="col-span-12 flex flex-col justify-center lg:col-span-7 fade-up">
          <p className="eyebrow mb-6">{t("hero.eyebrow")}</p>
          <h1 className="text-4xl font-extrabold leading-[1.05] tracking-tight text-[#0F2B48] sm:text-5xl lg:text-6xl" data-testid="hero-title">
            {profile?.hero_title}
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 md:text-lg">{profile?.hero_subtitle}</p>
          <div className="mt-10 flex flex-wrap gap-3">
            <a href="#konsultasi" data-testid="hero-consultation-button" className="group inline-flex items-center gap-2 bg-[#D97706] px-7 py-4 text-sm font-bold text-white transition-colors hover:bg-[#B45309]">
              {t("hero.cta")} <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </a>
            <button onClick={() => window.dispatchEvent(new Event("open-chat"))} data-testid="hero-chat-button" className="border border-[#0F2B48] px-7 py-4 text-sm font-bold text-[#0F2B48] transition-colors hover:bg-[#0F2B48] hover:text-white">
              {t("hero.chat")}
            </button>
          </div>
          <div className="mt-14 grid grid-cols-2 gap-px border border-slate-200 bg-slate-200 sm:grid-cols-4">
            {(profile?.stats || []).map((s, i) => (
              <div key={i} className="bg-white p-5" data-testid={`hero-stat-${i}`}>
                <div className="text-2xl font-extrabold text-[#0F2B48]">{s.value}</div>
                <div className="mt-1 text-xs text-slate-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative col-span-12 lg:col-span-5 fade-up" style={{ animationDelay: ".15s" }}>
          <div className="relative h-[420px] overflow-hidden lg:h-full lg:min-h-[560px]">
            <img src={HERO_IMG} alt="Gedung konstruksi" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B]/80 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 space-y-2 p-6">
              {[[ShieldCheck, t("hero.b1")], [Clock, t("hero.b2")], [FileCheck2, t("hero.b3")]].map(([Icon, label]) => (
                <div key={label} className="flex items-center gap-3 border border-white/15 bg-[#0B132B]/70 px-4 py-3 text-sm text-white backdrop-blur-md">
                  <Icon size={16} className="text-[#F59E0B]" /> {label}
                </div>
              ))}
            </div>
          </div>
          <div className="absolute -left-4 top-6 hidden bg-[#0F2B48] px-4 py-3 font-mono text-[11px] uppercase tracking-widest text-white lg:block">
            SBU · SKK · NIB · ISO · K3
          </div>
        </div>
      </div>
    </section>
  );
}
